import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

const COOLDOWN = 60;

export function ResendVerification({ email: initialEmail = "", editable = false, className = "" }) {
  const [email, setEmail] = useState(initialEmail);
  const [left, setLeft] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => { setEmail(initialEmail); }, [initialEmail]);
  useEffect(() => {
    if (left <= 0) return;
    const t = setTimeout(() => setLeft((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [left]);

  const send = async () => {
    if (!email) return toast.error("Isi email Anda");
    setLoading(true);
    try {
      const r = await api.post("/auth/resend-verification", { email });
      toast.success(r.data.message);
      setLeft(COOLDOWN);
    } catch (e) {
      const m = formatApiError(e);
      toast.error(m);
      const w = Number((m.match(/(\d+) detik/) || [])[1]);
      if (w) setLeft(w);
    } finally { setLoading(false); }
  };

  return (
    <div className={`space-y-2 ${className}`} data-testid="resend-verification">
      {editable && <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email yang didaftarkan" data-testid="resend-verification-email"/>}
      <Button type="button" variant="outline" onClick={send} disabled={loading || left > 0} className="w-full rounded-sm" data-testid="resend-verification-btn">
        <RefreshCw size={14} className={`mr-1.5 ${loading ? "animate-spin" : ""}`}/>
        {left > 0 ? `Kirim ulang dalam ${left} detik` : "Kirim ulang email verifikasi"}
      </Button>
      <p className="text-[11px] text-slate-400">Belum menerima email? Cek folder Spam/Promosi, atau kirim ulang.</p>
    </div>
  );
}
